module.exports = __webpack_public_path__ + "assets/1f00ac1d6bbfebb29af30547219557f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/pedro.jpg
// module id = 510
// module chunks = 0